module.exports = __webpack_public_path__ + "img/icon-healthcare.3dde1228.svg";